/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { N0, N200, N50, N700, primary, primaryDark } from '@assets/colors';

const getColors = (variant, active) => {
  switch (true) {
    case variant === 'filled' && active:
      return {
        textColor: N0,
        borderColor: primary,
        backgroundColor: primary,
        backgroundHoverColor: primaryDark,
      };
    case variant === 'filled' && !active:
      return {
        textColor: N700,
        borderColor: N200,
        backgroundColor: N200,
        backgroundHoverColor: N50,
      };
    case variant === 'outlined' && active:
    case variant === 'squared' && active:
      return {
        textColor: primary,
        borderColor: primary,
        backgroundColor: N0,
        backgroundHoverColor: N50,
      };
    case variant === 'outlined' && !active:
    case variant === 'squared' && !active:
    default:
      return {
        textColor: N700,
        borderColor: N200,
        backgroundColor: N0,
        backgroundHoverColor: N50,
      };
  }
};

export const DivTagContainer = styled('div')(
  ({ active, bold, block, disabled, size, variant }) => {
    const { textColor, borderColor, backgroundColor, backgroundHoverColor } = getColors(variant, active);

    return {
      display: 'inline-block',
      width: block ? '100%' : 'fit-content',
      marginRight: '4px',
      marginBottom: '4px',

      textAlign: 'center',
      lineHeight: 1.5,
      fontWeight: bold ? '700' : '400',
      color: textColor,
      border: `1px solid ${borderColor}`,
      borderRadius: '32px',
      backgroundColor,
      transition: 'background-color 100ms linear',

      ...(size === 'sm' && { padding: '4px 8px', fontSize: '12px' }),
      ...(size === 'md' && { padding: '8px 16px', fontSize: '14px' }),
      ...(size === 'lg' && { padding: '8px 16px', fontSize: '17px' }),

      ...(variant === 'squared' && { borderRadius: '4px' }),

      ...(disabled
        ? {
            backgroundColor: backgroundHoverColor,
          }
        : {
            cursor: 'pointer',
            ':hover': {
              backgroundColor: backgroundHoverColor,
            },
          }),
    };
  }
);
